import { BoxProps, Heading } from '@chakra-ui/react'
import { ContentNode } from '@helo/cms'
import { DataTypeConfigUtils } from '@helo/cms'
import { pipe } from '@helo/utils'
import { If } from '@helo/utils'

import { HeadingError } from '../../components/Errors/HeadingError'
import { Skeleton } from '../../components/SkeletonLoader'
import { TypeRenderer } from '../../datatypes/TypeRenderer'
import { createWidget } from '../widget-utils'

export type HeadingWidgetProps = BoxProps & {
  text?: string
  contentNode?: ContentNode
  isLoading?: boolean
  url?: string | boolean
}

export const HeadingWidget = ({
  text,
  contentNode,
  isLoading,
  ...props
}: HeadingWidgetProps) => {
  const hasTextContent = !!text
  const hasContentNode = !!contentNode
  const hasResolvedContent =
    hasTextContent ||
    (contentNode?.data != null && String(contentNode.data) !== '')
  const showSkeleton =
    Boolean(isLoading) ||
    (hasContentNode && !hasTextContent && !hasResolvedContent)

  if (!hasTextContent && !hasContentNode) {
    return null
  }

  const contentNodeWithStyles =
    contentNode &&
    pipe(
      contentNode,
      If.then(
        contentNode => contentNode.kind === 'FIELD',
        DataTypeConfigUtils.getOfType(),
      ),
      DataTypeConfigUtils.updateState({
        styles: { variant: 'pageTitle' },
        linkUrl: contentNode?.state?.linkUrl,
      }),
    )

  return (
    <Skeleton isLoading={showSkeleton} w="200px" h="28px">
      <Heading variant="pageTitle" {...props}>
        {hasTextContent ? (
          text
        ) : hasContentNode ? (
          <TypeRenderer
            contentNode={contentNodeWithStyles!}
            isLoading={isLoading}
          />
        ) : null}
      </Heading>
    </Skeleton>
  )
}

export const HeadingWidgetDefinition = createWidget(HeadingWidget, {
  type: 'Heading',
  errorRenderer: HeadingError,
})
